"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../../models");
var request_1 = require("./request");
var response_1 = require("./response");
exports.BOUNDARY = 'TEAM_ZUPAH_GEIL_OG';
function executeRequest(adapter, requests) {
    var requestConfig = {
        method: 'POST',
        url: request_1.makeFullUrl(models_1.Model.getBaseUrl(), 'communications/batch'),
        responseType: 'text',
        headers: {
            'Content-Type': "multipart/mixed; boundary=" + exports.BOUNDARY,
        },
        data: request_1.createRequestPayload(requests),
    };
    return adapter(requestConfig)
        .then(response_1.handleResponse)
        .catch(response_1.createGeneralErrorHandler(requests));
}
exports.executeRequest = executeRequest;
